<template>
  <div
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    v-loading="loading"
  >
    <!-- 选择学科暂时隐藏 -->
    <!-- <div
      :class="
        roleType == 'teacher' ? 'hejui' : roleType == 'school' ? 'hejui1' : ''
      "
    >
      <span
        v-for="item in sulist"
        :key="item.id"
        class="weixuan"
        :class="sulistid == item.id ? 'xuanzhong' : ''"
        @click="xuanxueke(item.id)"
        >{{ item.name }}</span
      > -->
    <!-- <el-select v-model="sulistid" placeholder="请选择">
				<el-option v-for="item in sulist" :key="item.id" :label="item.name" :value="item.id"></el-option>
			</el-select> -->
    <!-- </div> -->
    <el-calendar :first-day-of-week="7" v-model="value">
      <template slot="dateCell" slot-scope="{ date, data }">
        {{ data.day.split("-").slice(2).join("-") }}日
        <div
          v-for="(list, index) in list"
          v-if="data.day == list.curDay"
          :key="index"
          style="height: 80px; margin-top: 15px"
        >
          <div v-if="data.day == list.curDay">
            <!--<div style="margin-bottom: 15px;">{{ data.day.split('-').slice(2).join('-') }}日</div>-->
            <div v-if="list.courseOnLineVos.length > 0" class="popoverss">
              <el-popover placement="right" width="250" trigger="hover">
                <div
                  v-for="(dasth, index) in list.courseOnLineVos"
                  :key="index"
                  class="chuijiu linhyue"
                >
                  <div>主题：{{ dasth.courseName }}</div>
                  <div>学校：{{ dasth.schoolName }}</div>
                  <div>授课人：{{ dasth.courseSpeaker }}</div>
                  <div v-if="funhui(dasth.beginTime, dasth.endTime) !== 2">
                    开始时间：{{
                      dasth.beginTime.substring(0, dasth.beginTime.length - 3)
                    }}
                  </div>
                  <div v-if="funhui(dasth.beginTime, dasth.endTime) !== 2">
                    结束时间：{{
                      dasth.endTime.substring(0, dasth.endTime.length - 3)
                    }}
                  </div>
                  <div>
                    <!-- <div
											class="zhibos"
											v-if="funhui(dasth.beginTime,dasth.endTime)==1"
											@click="zhibo(dasth)"
										>直播暂未开始</div> -->
                    <!-- <div
											class="zhibos"
											v-if="funhui(dasth.beginTime,dasth.endTime)==2"
											@click="zhibo(dasth)"
										>进入直播</div> -->
                    <div v-if="funhui(dasth.beginTime, dasth.endTime) == 2">
                      直播时间：
                      <br />
                      {{
                        dasth.beginTime.substring(0, dasth.beginTime.length - 3)
                      }}
                      <br />
                      {{ dasth.endTime.substring(0, dasth.endTime.length - 3) }}
                    </div>
                    <!-- <div class="zhibos" v-if="dasth.videoSource==1" @click="kts(dasth)">进入直播</div> -->
                    <div
                      class="zhibos"
                      v-if="dasth.liveStatus == 1"
                      @click="kts(dasth)"
                    >
                      进入直播
                    </div>
                    <div
                      class="zhiboss"
                      v-if="dasth.liveStatus == 2"
                      @click="kts(dasth)"
                    >
                      暂未开始
                    </div>
                    <div
                      class="zhibos chajuis"
                      v-if="dasth.liveStatus == 3"
                      @click="zhibo(dasth)"
                    >
                      直播结束
                    </div>
                    <div
                      class="zhibos chajuis"
                      v-if="dasth.liveStatus == 4"
                      @click="zhibo(dasth)"
                    >
                      查看回放
                    </div>
                    <!-- <div
                      class="zhibos"
                      v-if="funhui(dasth.beginTime, dasth.endTime) == 2"
                      @click="kts(dasth)"
                    >
                      进入直播
                    </div>
                    <div
                      class="zhiboss"
                      v-if="funhui(dasth.beginTime, dasth.endTime) == 1"
                      @click="kts(dasth)"
                    >
                      暂未开始
                    </div>
                    <div
                      class="zhibos chajuis"
                      v-if="funhui(dasth.beginTime, dasth.endTime) == 3"
                      @click="zhibo(dasth)"
                    >
                      查看回放
                    </div> -->
                    <!-- <el-button
											round
											size="mini"
											v-if="funhui(dasth.beginTime,dasth.endTime)==3"
											@click="zhibo(dasth)"
										>查看回放</el-button> -->
                  </div>
                  <!-- <div v-for="(zl,index) in dasth.resPubVos" :key="index" style="margin: 15px 0 0 0;">
										<span class="huised" round size="mini" @click="openDetailss(zl.resId)">{{zl.fileName}}</span>
									</div> -->
                </div>
                <div
                  slot="reference"
                  v-for="(keshi, index) in list.courseOnLineVos"
                  :key="index"
                  v-if="index == 0"
                  class="linjui"
                >
                  {{ keshi.courseName }} 等{{
                    list.courseOnLineVos.length
                  }}个课程
                </div>
              </el-popover>
            </div>
          </div>
        </div>
      </template>
    </el-calendar>
  </div>
</template>

<script>
import {
  courseonlinelist,
  subjeclist,
  teachersubject,
  usercenterinfo,
  PcQuitUpate,
} from "@/api/home";
export default {
  data() {
    return {
      loading: false,
      list: [],
      value: new Date(),
      sulist: [],
      sulistid: "",
      roleType: "",
      teacherId: localStorage.getItem("teacherId"),
      times: "",
      timer: null,
      groupId: "",
    };
  },
  watch: {
    value() {
      this.courseonlinelist(this.value);
      var now = new Date(); // 当前日期
      var nowYear = now.getFullYear(); //当前年
      var nowMonth = now.getMonth(); //当前月 （值为0~11）
      var firstDay = new Date(nowYear, nowMonth, 1).getTime(); // 本月开始时间
      var LastDay = new Date(nowYear, nowMonth + 1, 0).getTime(); // 本月结束时间
      if (this.value > firstDay && this.value < LastDay) {
        // 添加当月样式
        this.listcor();
      } else {
        // 清除不是当月范围内的样式
        let is = document.getElementsByClassName("redbai")[0].parentNode
          .children;
        for (let i = 1; i < is.length - 1; i++) {
          is[i].classList.remove("redbai");
        }
      }
    },
    sulistid() {
      this.courseonlinelist(this.value);
    },
  },
  methods: {
    pcQuitUpates(id) {
      let params = {
        ip: returnCitySN.cip,
        lessonId: id,
      };
      PcQuitUpate(params).then((res) => {});
    },
    usercenterinfos() {
      usercenterinfo().then((res) => {
        this.groupId = res.data.data.groupId;
        let value = new Date();
        this.courseonlinelist(value);
      });
    },
    xuanxueke(s) {
      this.sulistid = s;
    },
    courseonlinelist(s) {
      let that = this;
      let date = {
        year: s.getFullYear(),
        month: s.getMonth() + 1,
        date: s.getDate(),
      };
      if (date.month < 10) {
        date.month = "0" + date.month;
      }
      that.loading = true;
      let params = {
        year: date.year,
        month: date.month,
        courseState: 1,
        // schoolId: localStorage.getItem("schoolId"),
        groupId: this.groupId || 1,
        classId: localStorage.getItem("classesId"),
        // subjectId: this.sulistid,
        roomTypes: 3,
        courseTypeid: 1,
      };
      courseonlinelist(params)
        .then((res) => {
          that.loading = false;
          for (var i = 0; i < res.data.data.length; i++) {
            if (res.data.data[i].curDay < 10) {
              res.data.data[i].curDay = "0" + res.data.data[i].curDay;
            }
            res.data.data[i].curDay =
              date.year + "-" + date.month + "-" + res.data.data[i].curDay;
            that.list = res.data.data;
          }
        })
        .catch(() => {
          that.loading = false;
        });
    },
    funhui(s, d) {
      var timestamp = new Date().getTime();
      var time = new Date(s.replace(/-/g, "/")).getTime();
      var time1 = new Date(d.replace(/-/g, "/")).getTime();
      if (time > timestamp) {
        return 1;
      } else if (time1 > timestamp) {
        return 2;
      } else if (timestamp > time1) {
        return 3;
      }
    },
    openDetailss(s) {
      let url = "http://bk.welaiedu.cn/#/prepare_pdf?id=" + s;
      window.open(url, "_blank");
    },
    zhibo(s) {
      localStorage.removeItem("lessonId");
      let routeData = this.$router.resolve({
        path: "/index",
        query: { id: s.lessonId },
      });
      window.open(routeData.href, "_blank");
    },
    kts(s) {
      localStorage.removeItem("lessonId");
      let routeData = this.$router.resolve({
        path: "/index",
        query: { id: s.lessonId },
      });
      window.open(routeData.href, "_blank");
    },
    subjeclist() {
      let that = this;
      that.loading = true;
      let params = {};
      subjeclist(params)
        .then((res) => {
          that.loading = false;
          that.sulist = res.data.data;
          let list = {
            id: "",
            name: "全部学科",
          };
          that.sulist.unshift(list);
        })
        .catch(() => {
          that.loading = false;
        });
    },
    teachersubject() {
      let that = this;
      that.loading = true;
      let params = {
        teacherId: localStorage.getItem("teacherId"),
      };
      teachersubject(params)
        .then((res) => {
          that.loading = false;
          that.sulist = res.data.data;
          that.sulistid = res.data.data[0].id;
        })
        .catch(() => {
          that.loading = false;
        });
    },
    teacherOrSchool() {
      this.roleType = localStorage.getItem("roleType");
      if (localStorage.getItem("roleType") == "teacher") {
        this.teachersubject();
      } else {
        this.subjeclist();
      }
    },
    clearIntervals() {
      if (this.teacherId !== null) {
        clearInterval(this.times);
        this.teacherOrSchool();
      }
    },
    listcor() {
      setTimeout(() => {
        let is = document.getElementsByClassName("is-today")[0].parentNode
          .children;
        for (let i = 1; i < is.length - 1; i++) {
          is[i].classList.add("redbai");
        }
      }, 200);
    },
  },
  created: function () {
    this.roleType = localStorage.getItem("roleType");
    const tokens = localStorage.getItem("token");
    if (!tokens) {
      let value = new Date();
      this.courseonlinelist(value);
    } else {
      this.usercenterinfos();
    }
  },
  beforeDestroy() {
    // 离开页面清除定时器 防止错乱
    clearInterval(this.timer);
  },
  mounted() {
    let that = this;
    window.addEventListener("storage", function (e) {
      let flag = localStorage.getItem("lessonId");
      if (flag) {
        that.pcQuitUpates(flag);
      }
    });
    const tokens = localStorage.getItem("token");
    if (tokens) {
      this.times = setInterval(() => {
        this.teacherId = localStorage.getItem("teacherId");
        this.clearIntervals();
      }, 500);
    }

    this.listcor();
    // 每五分钟刷新一次
    this.timer = setInterval(() => {
      let value = new Date();
      this.courseonlinelist(value);
    }, 300000);
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/index/zplay.vue